import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Profile from '../ProfilesMenu/Profile';
import PodBanner from '../../components/PodBanner';
import SchoolSize from './SchoolSize';
import NearestCity from './NearestCity';
import { getYearFromTimestamp } from '../../utils/timestamp';
import CampusPride from './CampusPride';
import DistanceFromHS from './DistanceFromHS';
import LivingOnCampus from './LivingOnCampus';
import Ethnicity from './Ethnicity';
import Gender from './Gender';
import Age from './Age';
import ResidencyStatus from './ResidencyStatus';
import International from './International';
import OrganizationsAndServices from './OrganizationsAndServices';
import HousingInfo from './HousingInfo';
import withHostContext from '../../context/host/consumer';

class StudentLifeMenu extends React.PureComponent {
  static propTypes = {
    profile: PropTypes.shape({
      custom_profiles: PropTypes.array,
    }),
    collegeName: PropTypes.string,
    undergraduateEnrollment: PropTypes.object,
    studentLifeData: PropTypes.object,
    highSchool: PropTypes.object,
  };

  render() {
    const {
      collegeName,
      undergraduateEnrollment,
      studentLifeData,
      highSchool,
      hostContext,
    } = this.props;
    const profile = this.props.profile || {};
    const alumniProfiles = []
      .concat(profile.custom_profiles || [])
      .filter((pr) => pr && pr.type === 'alumni');

    const lastUpdatedYear = getYearFromTimestamp(
      get(studentLifeData, 'lastUpdated.value', null),
    );
    const collegeLocation = get(studentLifeData, 'location');
    const ethnicity = get(studentLifeData, 'ethnicity');
    const age = get(studentLifeData, 'ageData');
    const isCamino = get(hostContext, 'isCamino', false);

    return (
      <div className="student-life-container common-full-width">
        <PodBanner
          footer={lastUpdatedYear ? `Latest available data from ${lastUpdatedYear}` : ''}
        >
          <CampusPride campusPride={get(studentLifeData, 'campusPride.value')} />
          <SchoolSize schoolSize={get(studentLifeData, 'schoolSize')} />
          <NearestCity nearestCity={get(studentLifeData, 'nearestCity')} />
          <DistanceFromHS highSchool={highSchool} college={collegeLocation} />
          <LivingOnCampus
            liveOnCampus={get(studentLifeData, 'housingData.liveOnCampus.value')}
          />
        </PodBanner>
        {alumniProfiles &&
          alumniProfiles.map((pr, index) => (
            <Profile
              key={pr.persons_name}
              profile={pr}
              showHeading={index === 0}
              collegeName={collegeName}
            />
          ))}
        <Ethnicity
          ethnicity={ethnicity}
          schoolSize={get(studentLifeData, 'schoolSize')}
          isCamino={isCamino}
        />
        <div className="common-core-width flex-and-centered">
          <Gender undergraduateEnrollment={undergraduateEnrollment} isCamino={isCamino} />
          <Age
            age={age}
            undergraduateEnrollment={undergraduateEnrollment}
            isCamino={isCamino}
          />
        </div>
        <div className="common-core-width flex-and-centered">
          <ResidencyStatus
            undergraduateEnrollment={undergraduateEnrollment}
            outOfStateData={get(studentLifeData, 'outOfStateData.value', null)}
            isCamino={isCamino}
          />
          <International
            international={get(ethnicity, 'international', {})}
            undergraduateEnrollment={undergraduateEnrollment}
            isCamino={isCamino}
          />
        </div>
        <HousingInfo
          housingData={get(studentLifeData, 'housingData', null)}
          lastUpdatedYear={lastUpdatedYear}
        />
        <div className="common-core-width">
          <OrganizationsAndServices
            organizations={get(studentLifeData, 'organizations', {})}
            athletics={get(studentLifeData, 'athletics', {})}
            greekLife={get(studentLifeData, 'greekLife', {})}
            services={get(studentLifeData, 'services', {})}
            computingResources={get(studentLifeData, 'computingResources', {})}
            lastUpdatedYear={lastUpdatedYear}
          />
        </div>
      </div>
    );
  }
}

export default withHostContext(StudentLifeMenu);
